
export const ExportVideoTypes = {
    FOURK_VIDEO: 'FourK',
    TEST_VIDEO: 'Test',
    FREE_VIDEO: 'Free',
};
